import styled, { css } from 'styled-components';

import { pxToRem } from 'utils/scss';

export const IconSearch = styled.div`
  position: absolute;
  top: 10px;
  right: 20px;
  font-size: 16px;
  :before {
    color: ${props => props.theme.colors.primary.purple};
  }
`;

export const SelectItems = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.lightGray3};
  border-left: 1px solid ${props => props.theme.colors.lightGray3};
  border-right: 1px solid ${props => props.theme.colors.lightGray3};
  background-color: ${props => props.theme.colors.white};
  width: 100%;
  display: ${props => (props.isOpen ? 'initial' : 'none')};
  position: absolute;
  left: 0px;
  top: 35px;
  z-index: 100;
  max-height: 400px;
  overflow-y: scroll;
  border-radius: 0 0 5px 5px;
  font-family: ${({ theme }) => theme.fontset.opensans};
  &.show-on-top {
    bottom: 35px;
    top: auto;
    border-radius: 5px 5px 0 0;
    border-bottom: none;
    border-top: 1px solid ${props => props.theme.colors.lightGray3};
  }
`;

export const Item = styled.div`
  color: ${props => props.theme.colors.black.one};
  font-style: normal;
  padding: 6px 24px 6px 14px;
  max-height: 29px;
  width: 100%;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  font-family: ${({ theme }) => theme.fontset.opensans};
  ${props =>
    props.framework &&
    css`
      color: black;
    `};

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed !important;
      opacity: 0.6;
    `};

  :hover {
    background-color: ${props => props.theme.colors.lightGray3};
  }
`;

const Input = styled.input`
  background-color: transparent;
  border: none;
  height: 100%;
  color: ${props => props.theme.colors.black.one};
  text-overflow: ellipsis;
  width: 90%;
  font-family: ${({ theme }) => theme.fontset.opensans};


  &::-webkit-outer-spin-button,
  &::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  &[type='number'] {
    -moz-appearance: textfield;
  }

  &:focus {
    outline: none;
  }
`;

const InputContainer = styled.div`
  position: relative;
  width: 100%;
  height: ${pxToRem('56px')};
  font-size: 1rem;
  border-radius: 5px;
  border: solid ${pxToRem('1px')} rgba(70, 122, 251, 0.56);
  background-color: ${props => props.theme.colors.white};
  font-family: ${({ theme }) => theme.fontset.opensans};
  margin: ${pxToRem('20px')} 0;
  outline: none;
  padding: ${pxToRem('12px')} ${pxToRem('29px')} ${pxToRem('12px')}
    ${pxToRem('20px')};
  ${props =>
    props.error &&
    css`
      border: solid ${pxToRem('1px')} ${props.theme.colors.statusRed};
    `};

  ${props =>
    props.focus &&
    css`
      border-color: black;
    `};

  ${props =>
    props.active &&
    !props.error &&
    css`
      border-color: black;
    `};

  ${props =>
    props.disabled &&
    css`
      cursor: not-allowed;
      opacity: 0.6;
      > input {
        cursor: not-allowed;
      }
    `};

  ${props =>
    props.iconVersion &&
    css`
      border-radius: 20px;
    `};
`;

const Icon = styled.span`
  position: absolute;
  top: 7px;
  right: 35px;
  font-size: 12px;
  cursor: pointer;
`;

const Error = styled.span`
  font-family: ${({ theme }) => theme.fontset.opensans};
  color: ${props => props.theme.colors.semantic.secondary};
  display: block;
  margin: 8px 0 0px;
`;

export { Input, InputContainer, Icon, Error };
